<template>
  <div class="open-vip-wrap">
    <div class="header">
      <div class="title">
        <p>元素魔方. 重磅升级</p>
        <p class="desc">升级团队账户专享多项VIP权益</p>
      </div>
      <div class="vip-type-wrap">
        <div :class="['vip-type1', 'vip-type', { 'active': vipType == 0 }]" @click="vipType = 0">
          <p>开通元素魔方普通会员</p>
          <p class="desc">立得<i>200元现金券</i> . 4000元信用额度</p>
        </div>
        <div :class="['vip-type2', 'vip-type', { 'active': vipType == 1 }]" @click="vipType = 1">
          <p>开通会员并升级团体账户</p>
          <p class="desc">升级立得<i>200元现金券+1500元券包</i> . 5万元信用额度</p>
          <div class="icon">升级权益</div>
        </div>
      </div>
    </div>

    <div class="team-vip-content" v-if="vipType == 1">
      <div class="top">
        <div class="title gold">会员基础权益</div>
        <div class="base-equity">
          <div class="item">
            <img src="~@/assets/images/equity_icon11.png" alt="">
            <div>
              <p class="title mb-2 gold">免费试样</p>
              <p class="desc gold">全场200元 无门槛立减金</p>
            </div>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon12.png" alt="">
            <div>
              <p class="title mb-2 gold">先测后付</p>
              <p class="desc gold">最低4000元额度 先测后付</p>
            </div>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon13.png" alt="">
            <div>
              <p class="title mb-2 gold">集积分兑豪礼</p>
              <p class="desc gold">加速积分 海量豪礼等你兑</p>
            </div>
          </div>
        </div>
        <div class="title">团体账户专享权益</div>
        <div class="update-equity-card">
          <div class="item">
            <img src="~@/assets/images/equity_icon14.png" alt="">
            <p class="title">团队开票管理</p>
            <p class="desc">统一给团体成员开票报销</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon15.png" alt="">
            <p class="title">1500元现金券</p>
            <p class="desc">1500元团体专享优惠券包</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon16.png" alt="">
            <p class="title">超高额度先测后付</p>
            <p class="desc">1500元团体专享优惠券包</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon17.png" alt="">
            <p class="title">便捷团队管理</p>
            <p class="desc">管理团队成员并设置消费限额</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon18.png" alt="">
            <p class="title">VIP团队管理</p>
            <p class="desc">成立VIP服务群，享受专人服务</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon19.png" alt="">
            <p class="title">论文写作AI工具</p>
            <p class="desc">人工智能助您轻松写论文</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon20.png" alt="">
            <p class="title">课题组网站</p>
            <p class="desc">免费创建课题组专属网站</p>
          </div>
        </div>
      </div>
      <div class="title">什么是团体账户</div>
      <div class="tip">
        团体账户是为高校课题组或企业设置的专属团队管理功能，负责人创建专属团体账户，成员在指南针注册的个人账号均可加入该团体账户中。团体账户可统一管理成员使用科研经费，统一开具发票报销，更加高效便捷地管理团队成员预约测试。
      </div>
      <div class="operate-btns">
        <div class="btn1 flex-cc">开通普通会员</div>
        <div class="btn2 flex-cc">开通会员并升级团体账户</div>
      </div>
    </div>
    <div class="vip-content" v-if="vipType == 0">
      <div class="top">
        <div class="title">会员基础权益</div>
        <div class="base-equity">
          <div class="item">
            <img src="~@/assets/images/equity_icon1.png" alt="">
            <div>
              <p class="title mb-2">免费试样</p>
              <p class="desc">全场200元 无门槛立减金</p>
            </div>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon2.png" alt="">
            <div>
              <p class="title mb-2">先测后付</p>
              <p class="desc">最低4000元额度 先测后付</p>
            </div>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon3.png" alt="">
            <div>
              <p class="title mb-2">集积分兑豪礼</p>
              <p class="desc">加速积分 海量豪礼等你兑</p>
            </div>
          </div>
        </div>
        <div class="title mb-4">升级团体账户即可享受以下权益</div>
        <div class="update-equity-card">
          <div class="item">
            <img src="~@/assets/images/equity_icon4.png" alt="">
            <p class="title">团队开票管理</p>
            <p class="desc">统一给团体成员开票报销</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon5.png" alt="">
            <p class="title">1500元现金券</p>
            <p class="desc">1500元团体专享优惠券包</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon6.png" alt="">
            <p class="title">超高额度先测后付</p>
            <p class="desc">1500元团体专享优惠券包</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon7.png" alt="">
            <p class="title">便捷团队管理</p>
            <p class="desc">管理团队成员并设置消费限额</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon8.png" alt="">
            <p class="title">VIP团队管理</p>
            <p class="desc">成立VIP服务群，享受专人服务</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon9.png" alt="">
            <p class="title">论文写作AI工具</p>
            <p class="desc">人工智能助您轻松写论文</p>
          </div>
          <div class="item">
            <img src="~@/assets/images/equity_icon10.png" alt="">
            <p class="title">课题组网站</p>
            <p class="desc">免费创建课题组专属网站</p>
          </div>
        </div>
      </div>
      <div class="level-introduce">
        <div class="title mb-2">会员等级介绍</div>
        <div class="desc">会员的等级按照账户的累积消费金额进行判定</div>
      </div>
      <div class="level-table">
        <div class="level-type">
          <div class="item">
            <div class="title mb-1">青铜会员</div>
            <div class="desc">免费加入</div>
          </div>
          <div class="item">
            <div class="title mb-1">黄金会员</div>
            <div class="desc">累计消费5000元</div>
          </div>
          <div class="item">
            <div class="title mb-1">铂金会员</div>
            <div class="desc">累计消费20000元</div>
          </div>
        </div>
        <div class="equity-table head">
          <p>会员等级</p>
          <p>信用额度</p>
          <p>集积分</p>
          <p>先测试后付款</p>
        </div>
        <div class="equity-table bg-odd">
          <p>青铜会员</p>
          <p>4000元</p>
          <p>消费1元=1积分</p>
          <p>√</p>
        </div>
        <div class="equity-table">
          <p>黄金会员</p>
          <p>6000元</p>
          <p>消费1元=1.5积分</p>
          <p>√</p>
        </div>
        <div class="equity-table bg-odd">
          <p>铂金会员</p>
          <p>12000元</p>
          <p>消费1元=2积分</p>
          <p>√</p>
        </div>
      </div>
      <div class="title">元素魔方会员常见问题</div>
      <div class="help-list">
        <div class="item">
          <div class="question">
            <div class="question-icon">问</div>
            <p>如何获得信用额度？</p>
          </div>
          <div class="answer">
            <div class="answer-icon">答</div>
            <p>你可以申请加入元素魔方会员，在加入会员页面中选择开通信用支付，并艰据页面指引完善身份信息，提交成功后将实时审核通过，立即成为会员并获得最高4000元信用额度</p>
          </div>
        </div>
        <div class="item">
          <div class="question">
            <div class="question-icon">问</div>
            <p>如何使用信用额度？</p>
          </div>
          <div class="answer">
            <div class="answer-icon">答</div>
            <p>在元素魔方下单支付时可以优先选择使用信用支付，无需支付现金0元下单。待实验完减后，用户对欠款订单进行还款操作即可恢复相对应的信用额度。</p>
          </div>
        </div>
        <div class="item">
          <div class="question">
            <div class="question-icon">问</div>
            <p>积分有什么用？</p>
          </div>
          <div class="answer">
            <div class="answer-icon">答</div>
            <p>积分可以兑换测试费用券、手机等各种好礼。</p>
          </div>
        </div>
        <div class="item">
          <div class="question">
            <div class="question-icon">问</div>
            <p>积分的计算规则是什么样的</p>
          </div>
          <div class="answer">
            <div class="answer-icon">答</div>
            <p>平台测试，参与不定期活动皆可获得积分，其中累计测试费用以计算会员等级，样品回收费用，寄送样品费用和预存支付/还款费用不被计算积分。</p>
          </div>
        </div>
        <div class="item">
          <div class="question">
            <div class="question-icon">问</div>
            <p>为什么我的累积消费金翻已经达到会员等级却没有升级？</p>
          </div>
          <div class="answer">
            <div class="answer-icon">答</div>
            <p>累计消费金额的计算规则为统计您所有已完成且不欠款的订单的实付金额之和。若您当前有未完成的订单，则该订单的金额暂时不会计算入内，需要等到订单完成且还款后方会计算入内。</p>
          </div>
        </div>
        <div class="item">
          <div class="question">
            <div class="question-icon">问</div>
            <p>如何获得更高的信用额度？</p>
          </div>
          <div class="answer">
            <div class="answer-icon">答</div>
            <p>通过多做实验，累计消费金额升级会员等级，即可获得更高的信用额度。</p>
          </div>
        </div>
      </div>
      <div class="operate-btns">
        <div class="btn1 flex-cc">开通会员并升级团体账户</div>
        <div class="btn2 flex-cc">开通普通会员</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/index";

export default {
  name: 'VipIndex',
  components: {

  },
  data() {
    return {
      loading: true,
      vipType: 0
    };
  },
  computed: {

  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getIndex({}).then(res => {

        this.loading = false;
        this.user = res.data;
      }).catch((err) => {

      });
    },
  }
};
</script>

<style lang="scss" scoped>
.open-vip-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .header {
    width: 100%;
    background-image: url(~@/assets/images/open_vip_bg.png);
    background-repeat: no-repeat;
    background-size: 105% 127%;
    background-position: 50% 59%;
    background-color: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 158px;
    box-sizing: border-box;
    z-index: 1;

    .title {
      font-size: 24px;
      font-weight: bold;
      color: #FFFFFF;
      margin-top: 52px;
      margin-bottom: 46px;
      text-align: center;

      .desc {
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 5px;
      }
    }

    .vip-type-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 50px;

      .vip-type {
        width: 500px;
        height: 120px;
        border-radius: 8px;
        padding-left: 39px;
        padding-top: 31px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        cursor: pointer;
      }

      .vip-type1 {
        background: rgba(167, 172, 178, 0.302);
        border: 1px solid #A7ACB2;
        font-size: 20px;
        font-weight: bold;
        color: #FFE9BA;

        .desc {
          font-size: 19px;
          font-weight: normal;
        }

        i {
          color: #FFFFFF !important;
        }
      }

      .vip-type2 {
        background: #F2E2B7;
        border: 1px solid #F2E2B7;
        font-size: 20px;
        font-weight: bold;
        color: #3E3947;
        position: relative;

        .icon {
          padding: 2px 25px;
          box-sizing: border-box;
          font-size: 16px;
          font-weight: bold;
          color: #FFFFFF;
          border-radius: 8px 18px 18px 0;
          position: absolute;
          left: -1px;
          top: -1px;
          background: #FF6666;
        }

        .desc {
          font-size: 19px;
          font-weight: normal;
        }

        i {
          color: #FF6666 !important;
        }
      }

      .active {
        width: 650px !important;
      }
    }
  }

  .team-vip-content {
    width: 1200px;
    box-sizing: border-box;
    margin-top: -10%;
    padding-bottom: 146px;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #222222;
      text-align: center;
      margin-bottom: 10px;
    }

    .desc {
      font-size: 16px;
      font-weight: 300;
      color: #222222;
      text-align: center;
    }

    .gold {
      color: #B57B4D !important;
    }

    .top {
      padding-top: 88px;
      box-sizing: border-box;
      width: 100%;
      background: linear-gradient(359deg, #F2E2B7 0%, #EFBE7C 100%);
      border-radius: 12px;

      .base-equity {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 98px;
        margin-top: 18px;
        margin-bottom: 52px;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 20px;
        }
      }

      .update-equity-card {
        width: 100%;
        box-sizing: border-box;
        border-radius: 12px 12px 12px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 82px;
        flex-wrap: wrap;
        row-gap: 43px;
        margin-top: 32px;
        padding-bottom: 42px;
        margin-bottom: 72px;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 10px;
        }
      }
    }

    .tip {
      width: 100%;
      padding: 39px 105px 42px 105px;
      box-sizing: border-box;
      background: #F2E2B7;
      border-radius: 12px;
      font-size: 20px;
      font-weight: 300;
      color: #222222;
      line-height: 38px;
      margin-top: 30px;
      margin-bottom: 104px;
    }

    .operate-btns {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      column-gap: 50px;

      .btn1 {
        width: 200px;
        height: 60px;
        border-radius: 30px;
        border: 1px solid #C2926C;
        font-size: 20px;
        font-weight: 400;
        color: #C2926C;
        cursor: pointer;
      }

      .btn2 {
        width: 299px;
        height: 60px;
        background: #B57B4D;
        border-radius: 30px;
        font-size: 20px;
        font-weight: bold;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }

  .vip-content {
    width: 1200px;
    padding-bottom: 137px;
    box-sizing: border-box;
    margin-top: -10%;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #222222;
      text-align: center;
      margin-bottom: 10px;
    }

    .desc {
      font-size: 16px;
      font-weight: 300;
      color: #222222;
      text-align: center;
    }

    .top {
      width: 100%;
      background: linear-gradient(1deg, #EBF1F3 0%, #A7ACB2 100%);
      border-radius: 12px;
      padding: 88px 40px 41px 40px;
      box-sizing: border-box;

      .base-equity {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 98px;
        margin-top: 18px;
        margin-bottom: 66px;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 20px;
        }
      }

      .update-equity-card {
        width: 100%;
        padding: 36px 65px 38px 65px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 12px 12px 12px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 82px;
        flex-wrap: wrap;
        row-gap: 43px;

        .title,
        .desc {
          color: #6F7F84;
        }

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          row-gap: 10px;
        }
      }
    }

    .level-introduce {
      width: 100%;
      margin-top: 78px;
    }

    .level-table {
      margin-top: 29px;
      margin-bottom: 85px;

      .level-type {
        border-radius: 12px 12px 0 0;
        width: 100%;
        height: 88px;
        background: #3E3947;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 256px;

        .title,
        .desc {
          color: #FFFCFC;
        }
      }

      .equity-table {
        width: 100%;
        height: 40px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        align-items: center;
        text-align: center;
      }

      .head {
        background: #A0A9AC;
        font-size: 16px;
        font-weight: bold;
        color: #FFFFFF;
      }

      .bg-odd {
        background: #F4F8F9 !important;
      }
    }

    .help-list {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      align-items: center;
      margin-top: 28px;
      margin-bottom: 76px;

      .item {
        width: 100%;
        background: #ebf1f38c;
        border-radius: 12px;
        padding: 20px 170px 17px 156px;
        box-sizing: border-box;

        .question,
        .answer {
          display: grid;
          grid-template-columns: 20px auto;
          column-gap: 16px;
        }

        .question {
          font-size: 16px;
          font-weight: bold;
          color: #222222;
          margin-bottom: 20px;
        }

        .answer {
          font-size: 16px;
          font-weight: 300;
          color: #222222;
          line-height: 28px;
        }

        .answer-icon {
          width: 20px;
          height: 20px;
          background: #FFFFFF;
          box-shadow: 0px 0px 3px 1px #CCD7DB;
          font-size: 16px;
          font-weight: 400;
          color: #6F7F84;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3px;
        }

        .question-icon {
          width: 20px;
          height: 20px;
          background: #6F7F84;
          box-shadow: 0px 0px 3px 1px #CCD7DB;
          font-size: 16px;
          font-weight: 400;
          color: #FEFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3px;
        }
      }
    }

    .operate-btns {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      column-gap: 50px;

      .btn1 {
        width: 299px;
        height: 60px;
        border-radius: 30px;
        border: 1px solid #3E3947;
        font-size: 20px;
        font-weight: 400;
        color: #3E3947;
        cursor: pointer;
      }

      .btn2 {
        width: 200px;
        height: 60px;
        background: #3E3947;
        border-radius: 30px;
        font-size: 20px;
        font-weight: bold;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}
</style>
